var map = {
	"./approved.svg": "f6ec",
	"./btns/send.svg": "1c53",
	"./modal/alert.svg": "17c0",
	"./navs/eye.svg": "9c9b",
	"./pending.svg": "262a",
	"./rejected.svg": "720d",
	"./retraction.svg": "0864",
	"./tables/arrow-down-s-fill.svg": "3117",
	"./tables/checkbox-selected.svg": "0741",
	"./tables/checkbox.svg": "b50e",
	"./tables/eye-line.svg": "e5c1",
	"./uploader/pdf.svg": "fafd",
	"./uploader/remove.svg": "df34",
	"./uploader/vector.svg": "86b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b58";